import { getFunctions, httpsCallable } from 'firebase/functions';

export default async function queryTestStandProcessData({ startTime, endTime }) {
  const fn = httpsCallable(getFunctions(), 'queryTestStandProcessDataV2');
  const result = await fn({
    startTime: new Date(startTime).toISOString(),
    endTime: new Date(endTime).toISOString(),
  });
  return result.data;
}
